import React from "react";
import CpntHeader from "./CpntHeader";
import { useNavigate } from "react-router-dom";
import { useKeycloak } from "@react-keycloak/web";
import CpntHeaderFODropDownOptions from "./CpntHeaderFODropDownOptions";
import { useDispatch } from "react-redux";
import { resetCompte } from "../redux/slice/compte.slice";


const CpntHeaderFO: React.FC = () => {

  const navigate = useNavigate();
  const {keycloak} = useKeycloak();
  const dispatch = useDispatch();
  
  const handleDisconnection = async () => {
    navigate("/");
    //await dispatch(clearPanier());
    dispatch(resetCompte());
    keycloak.logout();
  };

  const handleConnection = async () => {
    keycloak?.login({ loginHint: "" });
  };


  return (
    <CpntHeader logout={handleDisconnection} login={handleConnection} menu={<CpntHeaderFODropDownOptions />} accueilPath="./" libelleButtonConnexion="Connexion / Inscription" >
    </CpntHeader>
  );
}

export default CpntHeaderFO;


